exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinner_26p5scFSa49dZwoXlmaL52 {\n  width: 20px;\n  height: 20px;\n  float: left;\n  position: relative;\n  margin-right: 10px;\n  -webkit-animation: spin_2LPQZwYB5XtOH8XqV9j3VP 700ms linear infinite;\n  -moz-animation: spin_2LPQZwYB5XtOH8XqV9j3VP 700ms linear infinite;\n  animation: spin_2LPQZwYB5XtOH8XqV9j3VP 700ms linear infinite;\n}\n\n.IProgressList_Item_2OygpPr88v9xG73g_3ceNN{\n  margin-top: 15px;\n  font-size: 1.25rem;\n}", ""]);

// Exports
exports.locals = {
	"spinner": "spinner_26p5scFSa49dZwoXlmaL52",
	"spin": "spin_2LPQZwYB5XtOH8XqV9j3VP",
	"IProgressList_Item": "IProgressList_Item_2OygpPr88v9xG73g_3ceNN"
};